import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import About from "./Components/About/About";
import Blog from "./Components/Blog/Blog";
import Contact from "./Components/Contact/Contact";
import Home from "./Components/Home/Home/Home";
import Works from "./Components/Works/Works";

function App() {
    return (
        <Router>
            <Switch>
                <Route exact path="/">
                    <Home></Home>
                </Route>
                <Route path="/home">
                    <Home></Home>
                </Route>
                <Route path="/about">
                    <About></About>
                </Route>
                <Route path="/work">
                    <Works></Works>
                </Route>
                <Route path="/blog">
                    <Blog></Blog>
                </Route>
                <Route path="/contact">
                    <Contact></Contact>
                </Route>
            </Switch>
        </Router>
    );
}

export default App;
